import { render, staticRenderFns } from "./Favoritos.vue?vue&type=template&id=efc773c4"
import script from "./Favoritos.vue?vue&type=script&lang=js"
export * from "./Favoritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports